function getStore(storeName) {
  if (localStorage) return JSON.parse(localStorage.getItem(storeName)) || []

  return []
}

function saveStore(storeName, store) {
  if (localStorage) localStorage.setItem(storeName, JSON.stringify(store))
}

const MAX_DATA_SAVED = 3

function createInstance({ name }) {
  return {
    clear() {
      const store = []
      saveStore(name, store)

      return Promise.resolve(store)
    },
    toArray() {
      const store = getStore(name)

      return Promise.resolve(store)
    },
    put(item) {
      const store = getStore(name)
        .filter(({ title }) => title !== item.title)
        .reverse()
      store.push(item)
      saveStore(name, store.slice(-MAX_DATA_SAVED).reverse())

      return Promise.resolve(store)
    },
  }
}

export const db = {}

db.recentSearches = createInstance({ name: 'recentSearches' })
